import { api } from './client';

export interface SisReturnPoolRow {
  id: string;
  partyId: number;
  storeName: string;
  storeGroup: string;
  itemId: number;
  itemCode: string;
  itemName: string;
  itemBarcode: string;
  unit: string;
  qty: number;
  value: number;
  invoiceNo: string;
  batchNo: string;
  returnedAt: string;
  status: string; // Open | Received
  receivedAt: string | null;
  receivedBy: string | null;
}

export interface SisReturnPoolResponse {
  data: SisReturnPoolRow[];
  summary: { openLines: number; openQty: number; openValue: number };
}

export async function listSisReturnPool(filter: { status?: string; partyId?: number } = {}): Promise<SisReturnPoolResponse> {
  const r = await api.get<SisReturnPoolResponse>('/sis-return-pool', { params: filter });
  return r.data;
}

export async function receiveSisReturnPool(id: string): Promise<{ ok: boolean; id: string; receivedQty: number }> {
  const r = await api.post(`/sis-return-pool/${id}/receive`);
  return r.data;
}
